module.exports = __webpack_public_path__ + "img/video1.b20fe5a4.png";